import $ from 'jquery';

window.addEventListener('px-ready',function() {
    $('[id^="more"]').each(function() {
        var $parent = $(this).parent('p'), wrapperClass = $(this).attr('id')+'-wrapper';
        $parent.nextAll().wrapAll('<div class="'+wrapperClass+'" hidden></div>');
        
        $parent.after('<a class="'+wrapperClass+'" data-uk-toggle="target: .'+wrapperClass+'">En savoir plus</a>');
    });
});